import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Loading from '../common/Loading';
import Api from '../common/Api.js';
import jwt_encode from 'jwt-encode';
import jwt_decode from 'jwt-decode';
import Footer from '../common/Footer';
import Header from '../common/Header';
import CustomerAuth from '../common/CustomerAuth';

function Kyc() {
  const [pageloading, setpageLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState({ upi_id: '' });
  const [errors, setErrors] = useState({});

  // ---------------------------------------------------------------------------
  // Load current UPI (if any)
  // ---------------------------------------------------------------------------
  useEffect(() => {
    const customer = JSON.parse(localStorage.getItem('login-token'));
    setpageLoading(true);

    const fetchdata = async () => {
      try {
        const res = await Api.post(
          'customers/profile',
          jwt_encode(customer, process.env.REACT_APP_SECRET_KEY)
        );
        const result = jwt_decode(res.data);
        if (result.data.status === 'failure') {
          toast.error(result.data.errors.msg, {
            position: 'bottom-right', autoClose: 5000,
          });
        } else {
          const prof = result.data.data || {};
          console.log(prof);
          setProfile({ upi_id: prof.upi_id || '' });
        }
      } catch (err) {
        toast.error('Failed to load profile.', {
          position: 'bottom-right', autoClose: 5000,
        });
      } finally {
        setpageLoading(false);
      }
    };

    fetchdata();
  }, []);

  // ---------------------------------------------------------------------------
  // Handlers
  // ---------------------------------------------------------------------------
  const handleChange = (event) => {
    event.persist();
    const { name, value } = event.target;
    setProfile({ ...profile, [name]: value });

    // light client-side check
    if (name === 'upi_id') {
      if (value === '') {
        setErrors((prev) => ({ ...prev, upi_id: '' }));
      } else if (!/^[a-zA-Z0-9._-]{2,}@[a-zA-Z]{2,}$/.test(value)) {
        setErrors((prev) => ({ ...prev, upi_id: 'Enter a valid UPI ID (e.g. name@bank).' }));
      } else {
        setErrors((prev) => ({ ...prev, upi_id: '' }));
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const customer = JSON.parse(localStorage.getItem('login-token') || '{}');

    const payload = {
      id: customer.id,
      mobile: customer.mobile,
      upi_id: profile.upi_id || '',
    };

    try {
      const res = await Api.post(
        'customers/kyc',
        jwt_encode(payload, process.env.REACT_APP_SECRET_KEY)
      );
      const result = jwt_decode(res.data);
      setLoading(false);

      if (result.data.status === 'failure') {
        setErrors(result.data.errors || {});
      } else {
        setErrors({});
        toast.success('Your UPI ID updated successfully !!!', {
          position: 'bottom-right', autoClose: 5000,
        });
      }
    } catch (err) {
      setLoading(false);
      toast.error('Something went wrong. Please try again.');
    }
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  return (
    <>
      <CustomerAuth />
      <Header />
      <section className="w3l-faq-main">
        <div className="faq-sec sec-padding">
          <div className="wrapper">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">UPI Details</h3>
                    <br />
                    <p style={{ fontSize: '14px', color: '#ffffff' }}>
                      Please add your UPI ID so rewards can be sent directly to your account.
                    </p>
                  </div>

                  {pageloading ? (
                    <Loading />
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="upi_id">UPI ID</label>
                              <input
                                type="text"
                                id="upi_id"
                                name="upi_id"
                                value={profile.upi_id || ''}
                                onChange={handleChange}
                                className={errors.upi_id ? 'form-control is-invalid' : 'form-control'}
                                placeholder="e.g. yourname@okhdfcbank"
                              />
                              {errors.upi_id && (
                                <span className="error invalid-feedback">{errors.upi_id}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer">
                        <button type="submit" className="btn button-eff" disabled={loading}>
                          <span style={{ marginLeft: '35px' }}>Submit</span>
                          <span
                            style={{
                              float: 'right',
                              width: '10px',
                              height: '10px',
                              marginLeft: '5px',
                            }}
                          >
                            {loading && <i className="fa fa-circle-o-notch fa-spin"></i>}
                          </span>
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Kyc;